import React, { ReactElement } from 'react';
import { Breadcrumbs, homeBreadcrumb } from 'slovlex-idsk-react-components';
import { Loader } from 'idsk-react-components';
import { useLocation, useParams } from 'react-router';
import Layout from '../../Layout';
import routes from '../../../routing/routes';
import GlobalErrors from '../../../module/GlobalErrors';
import SecuredPage from '../../../module/SecuredPage';
import PageHeadingWithBackButton from '../../../module/PageHeadingWithBackButton';
import { DolozkaZlucitelnosti }
  from '../../../module/SprievodnyDokument/CreateFromForm';
import {
  updateDolozkaZlucitelnostiClient,
} from '../../../client/external/evidencnaaplikacia/dolozkaZlucitelnostiClient';
import useDolozkaZlucitelnostiFormData from './hook/useDolozkaZlucitelnostiFormData';
import isPredbeznaInformacia from '../../../function/isPredbeznaInformacia';
import SuccessMessages from '../../../module/SuccessMessages';
import { useClient } from '../../../context/ClientStatusContext';

const DolozkaZlucitelnostiEditPage = (): ReactElement => {
  const location = useLocation();
  const {
    type,
    year,
    index,
    stadiumUuid,
    // @ts-ignore
  } = useParams<{ type: string, year: number, index: number, stadiumUuid: string }>();

  const {
    formDataResponse,
    formDataStatus,
  } = useDolozkaZlucitelnostiFormData(
    type,
    year,
    index,
    stadiumUuid,
  );

  const {
    wrapClient: updateDolozkaZlucitelnosti,
  } = useClient(updateDolozkaZlucitelnostiClient);

  return (
    <Layout>
      <Breadcrumbs routeList={[
        homeBreadcrumb(process.env.REACT_APP_PORTAL_MAIN_URL),
        {
          heading: isPredbeznaInformacia(type) ? 'Predbežné informácie' : 'Legislatívne procesy',
          to: isPredbeznaInformacia(type) ? routes.procesy.predbeznaInformacia.list : routes.procesy.list,
        },
        {
          heading: `${type}/${year}/${index}`,
          to: routes.procesy.detail.withParams(type, year, index),
        },
        {
          heading: 'Sprievodná dokumentácia',
          to: routes.procesy.detail.sprievodneDokumenty.edit.withParams(type, year, index),
        },
        {
          heading: 'Doložka zlučiteľnosti',
          to: location.pathname,
        },
      ]}
      />
      <GlobalErrors />
      <Loader loading={formDataStatus.loading}>
        {formDataStatus.finished && (
        <SecuredPage
          hasOpravneniePracovneKroky={formDataResponse?.materialDetail?.hasOpravnenieSprievodneDokumenty}
          requestStatus={formDataStatus?.responseCode}
        >
          <>
            <SuccessMessages />
            {formDataResponse?.materialDetail && formDataResponse?.formData && (
            <>
              <PageHeadingWithBackButton
                headingCaption={`Legislatívny proces ${formDataResponse.materialDetail.cisloLegislativnehoMaterialu}`}
                heading="Doložka zlučiteľnosti"
                withBackLink
              />
              <DolozkaZlucitelnosti
                onSubmit={updateDolozkaZlucitelnosti}
                material={formDataResponse.materialDetail}
                initFormData={formDataResponse.formData}
              />
            </>
            )}
          </>
        </SecuredPage>
        )}
      </Loader>
    </Layout>
  );
};

export default DolozkaZlucitelnostiEditPage;
